import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { IMAGES } from "../constants/theme";
import NewsLetter from "../elements/NewsLetter";
import PageTitle from "../elements/PageTitle";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const API_URL = `${API_BASE}/courses`;

const Courses = () => {
  const { idPack } = useParams();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [packName, setPackName] = useState(null);

  useEffect(() => {
    async function fetchCourses() {
      try {
        setLoading(true);
        setError(null);

        const res = await fetch(`${API_URL}/${idPack}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (!res.ok) {
          const errorData = await res.json().catch(() => ({}));
          throw new Error(errorData.error || `Failed to fetch courses: ${res.statusText}`);
        }

        const data = await res.json();
        setCourses(data);
        
        // Get pack name from first course if available
        if (data.length > 0 && data[0].pack_name) {
          setPackName(data[0].pack_name);
        }
      } catch (err) {
        console.error("Error fetching courses:", err);
        setError(err.message || "Failed to load courses. Please try again later.");
      } finally {
        setLoading(false);
      }
    }

    if (idPack) {
      fetchCourses();
    } else {
      setError("Invalid pack ID");
      setLoading(false);
    }
  }, [idPack]);

  return (
    <div className="page-wraper">
      <div className="page-content" style={{ backgroundColor: "#fdffa2ff" }}>
        <PageTitle 
          activePage={packName || "Courses"} 
          parentTitle="Courses" 
        />

        <section className="content-inner">
          <div className="container py-5">
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            {loading && !error && (
              <div
                className="boxes"
                style={{ margin: "40px auto", width: "96px", height: "64px" }}
              >
                <div className="box">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <div className="box">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <div className="box">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <div className="box">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            )}

            {!loading && !error && courses.length > 0 && (
              <>
                {packName && (
                  <div className="mb-4 text-center">
                    <h3 className="fw-bold">{packName}</h3>
                    <p className="text-muted">
                      {courses.length} {courses.length === 1 ? "course" : "courses"} available
                    </p>
                  </div>
                )}
                <div className="packages-grid courses-grid-mobile">
                  {courses.map((course) => (
                    <div className="package-card" key={course.id}>
                      <img
                        src={
                          course.cover_image ||
                          IMAGES.placeholder ||
                          "/images/default-course.jpg"
                        }
                        alt={course.title}
                        onError={(e) => {
                          e.target.src = IMAGES.placeholder || "/images/default-course.jpg";
                        }}
                      />

                      <div className="package-card-body">
                        <div>
                          <h4>{course.title}</h4>
                          <p>{course.description || "No description available."}</p>
                          <div className="mt-2">
                            <small className="d-block text-muted mb-1">
                              <strong className="fw-bold">Category:</strong> {course.category_name || "Uncategorized"}
                            </small>
                            <small className="d-block text-muted">
                              <strong className="fw-bold">Level:</strong> {course.level || "N/A"}
                            </small>
                            {course.coach_name && (
                              <small className="d-block text-muted mt-1">
                                <strong className="fw-bold">Coach:</strong> {course.coach_name}
                              </small>
                            )}
                          </div>
                        </div>

                        <Link
                          to={`/Categories/Category/${course.category_id || ''}/Pack/${idPack}/Courses/${course.id}/lessons`}
                          className="btn btn-dark mt-3"
                        >
                          View Course
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
                <style>{`
                  @media (max-width: 767px) {
                    .courses-grid-mobile {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: center;
                      width: 100%;
                    }
                    
                    .courses-grid-mobile .package-card {
                      width: 100%;
                      max-width: 100%;
                      margin: 0 auto 20px auto;
                    }
                  }
                `}</style>
              </>
            )}

            {!loading && !error && courses.length === 0 && (
              <div className="text-center py-5">
                <p className="text-muted">No courses available in this pack.</p>
              </div>
            )}
          </div>
        </section>

        <section className="call-action style-1 footer-action">
          <div className="container">
            <NewsLetter />
          </div>
        </section>
      </div>
    </div>
  );
};

export default Courses;
